import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  padding: 35px 25px;

  > p {
    font: ${font('default', 'bold', '19px/1')};
    margin: 0 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    a {
      font: ${font('default', 'medium', '15px/1')};
      color: ${props => props.theme.palette.primary.alpha};
      text-decoration: none;
    }
  }
`
